export default __webpack_public_path__ + "static/how_it_works_2-0b332b842b415a1b0011349ed6731fda.png";